// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rv-c";
export var backButton = "_rv-4";
export var backIcon = "_rv-5";
export var chevronShortcut = "_rv-6";
export var container = "_rv-1";
export var editor = "_rv-8";
export var editorWrapper = "_rv-7";
export var prefix = "_rv-2";
export var searchIcon = "_rv-3";
export var suffix = "_rv-9";
export var suffixContent = "_rv-a";
export var suffixText = "_rv-b";
export var wrapper = "_rv-0";